import React from 'react';
import {useMenu} from "./contexts/menu-context";
import MainMenu from "./components/main-menu";

const AppMenu: React.FC = () => {
    const {currentMenuComponent} = useMenu();

    if (currentMenuComponent) {
        const MenuComponent = currentMenuComponent;
        return <MenuComponent />;
    }

    return <MainMenu/>;
};

export default AppMenu;
